import { useQuery } from '@abyss/web/hooks/useQuery';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import DecisionReasons from './DecisionReasons.gql';

export const useDecisionReasons = (options) => {
  return useQuery(DecisionReasons, {
    ...options,
    url: ApiUrl.graphQl(),
  });
};
